<template>
  <!-- Interac Gigadat -->
  <div id="interacForm" class="form_bottom_row line clearfix">
    <div class="fr img_row">
      <img src="@/assets/images/channel/interac.png" alt />
      <!-- <img src="@/assets/images/withdraw/interac.png" alt /> -->
    </div>
    <div class="fl form_row">
      <el-form :model="TransferForm" ref="TransferForm" :rules="TransferFormRules">
        <ul class="form_list clearfix">
          <li>
            <ImportantNotesInput
              :label="$t('common.field.imptNotes')"
              name="importantNotes"
              v-model="TransferForm.notes_interac"
            ></ImportantNotesInput>
          </li>
        </ul>
        <div class="alert_info">
          {{ $t('withdraw.default.interacGigadatAlert1') }}
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import ImportantNotesInput from '@/components/form/ImportantNotesInput';

export default {
  name: 'InteracGigadatWithdraw',
  props: ['accountNumber', 'amount', 'withdrawalType'],
  components: { ImportantNotesInput },
  data() {
    return {
      TransferForm: {
        interacEmial_interac: '',
        notes_interac: ''
      },
      TransferFormRules: {}
    };
  },
  methods: {
    getFormData() {
      return {
        qAccount: this.accountNumber,
        amount: this.amount,
        withdrawalType: this.withdrawalType,
        importantNotes: this.TransferForm.notes_interac
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.img_row img {
  max-width: 250px;
}
</style>
